"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/** Minimal health check page when the host serves the SPA for `/ping`. */
var Ping = function () {
    return ((0, jsx_runtime_1.jsx)("pre", { style: {
            margin: 0,
            padding: "1rem",
            fontFamily: "system-ui, sans-serif",
            fontSize: "1rem",
        }, children: "OK" }));
};
exports.default = Ping;
